import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoMarkProps {
    className?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 64 64' className={cn('size-8', className)} aria-hidden='true'>
            <rect width='64' height='64' rx='16' fill='#14111f' />
            <path d='M14 20a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v6a6 6 0 0 0 0 12v6a4 4 0 0 1-4 4H18a4 4 0 0 1-4-4v-6a6 6 0 0 0 0-12z' fill='#5b3cf0' />
            <path d='M27 24h10M32 24v16' stroke='#ffffff' strokeWidth='4' strokeLinecap='round' />
            <circle cx='44' cy='20' r='5' fill='#d4f24a' />
        </svg>
    )
}

interface LogoProps {
    href?: string
    tone?: 'light' | 'dark'
    className?: string
}

export const Logo: FC<LogoProps> = ({ href = '/', tone = 'light', className }): ReactNode => {
    return (
        <Link
            href={href}
            className={cn('inline-flex items-center gap-2.5 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring', className)}
            aria-label={`${siteConfig.name} home`}
        >
            <LogoMark className={tone === 'dark' ? 'ring-1 ring-white/15 rounded-[10px]' : undefined} />
            <span className={cn('font-heading text-xl font-extrabold tracking-tight', tone === 'dark' ? 'text-white' : 'text-foreground')}>
                {siteConfig.name}
            </span>
        </Link>
    )
}
